var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoordinate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4795 17.7084H6.14616C3.10449 17.7084 1.35449 15.9584 1.35449 12.9167V7.08342C1.35449 4.04175 3.10449 2.29175 6.14616 2.29175H14.4795C17.5212 2.29175 19.2712 4.04175 19.2712 7.08342V12.9167C19.2712 15.9584 17.5212 17.7084 14.4795 17.7084ZM6.14616 3.54175C3.76283 3.54175 2.60449 4.70008 2.60449 7.08342V12.9167C2.60449 15.3001 3.76283 16.4584 6.14616 16.4584H14.4795C16.8628 16.4584 18.0212 15.3001 18.0212 12.9167V7.08342C18.0212 4.70008 16.8628 3.54175 14.4795 3.54175H6.14616Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 10.725C9.61248 10.725 8.90415 10.5083 8.36248 10.0666L5.75414 7.98331C5.48748 7.76664 5.43748 7.37497 5.65415 7.10831C5.87081 6.84164 6.26248 6.79164 6.52915 7.00831L9.13748 9.09165C9.77081 9.59998 10.8458 9.59998 11.4791 9.09165L14.0875 7.00831C14.3541 6.79164 14.7541 6.83331 14.9625 7.10831C15.1791 7.37497 15.1375 7.77498 14.8625 7.98331L12.2541 10.0666C11.7208 10.5083 11.0125 10.725 10.3125 10.725Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinate);
export default __webpack_public_path__ + "static/media/coordinate.05c3925ce750d3283efe9238106f2d33.svg";
export { ForwardRef as ReactComponent };